// external
import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames";
// components
import ModelCard from "../../components/ModelCard";
import Loader from "components/partials/loader/loader";

// state managing/security
import { FaoBuilderContext } from "../../context/FaoBuilderContext";

// assets
import Icons from "assets/icons";

function FaoView() {
  const { fetchModels } = useContext(FaoBuilderContext);
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchModels(setIsLoading, setError, setModels, "draft");
  }, []);

  return (
    <div className="flex min-h-full w-full flex-col">
      <div className="w-full">
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-03">
            Existing FAO Models
          </h2>
          <div className="flex">
            <Icons.Info customClass="h-4 w-4 text-gray-500 mr-1 mt-1" />
            <p className="text-gray-500">
              This page displays all draft FAO models that are currently in
              progress. Click on any model to continue working on it from your
              last saved progress.
            </p>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : error || (!isLoading && models.length === 0) ? (
          <div className="flex h-64 items-center justify-center">
            <p
              className={classNames({
                "text-red-500": error,
                "text-gray-500": isLoading,
              })}
            >
              {error || "No draft models found"}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {models.map((model) => (
              <ModelCard key={model.id} model={model} disabled={false} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FaoView;
